module.exports = __webpack_public_path__ + "media/images/patterns/dot-85e0fcf15bc88a571e9f4df1008c5662.svg";